export const ALL_SERVICES = 'all-services'

export const AbstractionCategory = [ '1D sequence', '2D topology', '3D structure', 'xD omics' ]



// WEBPACK FOOTER //
// ./src/constants/stringConstants.js